export const defaultPositionsColumns = [
  {
    label: 'total',
    show: true,
  },
  {
    label: 'averagePrice',
    show: true,
  },
  {
    label: 'margin',
    show: true,
  },
  {
    label: 'pnl',
    show: true,
  },
  {
    label: 'realized_pnl',
    show: true,
  },
  {
    label: 'estimateLiquidationPrice',
    show: true,
  },
  {
    label: 'markPrice',
    show: true,
  },
  {
    label: 'marginRatio',
    show: true,
  },
  {
    label: 'action',
    show: true,
  },
  {
    label: 'closeAll',
    show: true,
  },
  {
    label: 'reverse',
    show: true,
  },
  {
    label: 'tpSlPrice',
    show: true,
  },
  {
    label: 'trailingStop',
    show: true,
  },
  {
    label: 'adl',
    show: true,
  },
];
